import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "./Routes/routes";
import { Toaster as SoonerToaster } from "./components/ui/sonner";
import { Toaster } from "./components/ui/toaster";

const App = () => {
  return (
    <>
      <RouterProvider router={router} />
      <Toaster />
      <SoonerToaster />
    </>
  );
};

export default App;
